<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Benefit Submitted</h3>
</div>
<div class="modal-body" id="modal_size">
    <p>{{modalText}}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="okClicked()">Okay</button>
</div>
